import { Link } from 'react-router-dom';
import type { FC } from 'react';
import { categories } from '@/mocks/videos';

interface CategoryNavProps {
  activeCategory: string;
  onCategoryChange: (slug: string) => void;
}

const CategoryNav: FC<CategoryNavProps> = ({ activeCategory, onCategoryChange }) => {
  return (
    <section className="py-8">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-2 mb-6">
          <div className="w-1 h-5 bg-primary-500 rounded-full"></div>
          <h2 className="text-lg font-heading font-semibold text-foreground-100">视频分类</h2>
        </div>
        <div className="flex flex-wrap items-center gap-2">
          {categories.map((cat) => (
            <button
              key={cat.slug}
              onClick={() => onCategoryChange(cat.slug)}
              className={`whitespace-nowrap px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer flex items-center gap-2 ${
                activeCategory === cat.slug
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-300 hover:text-foreground-100 hover:bg-background-200 border border-background-300/30'
              }`}
            >
              <i className={`${cat.icon} text-sm`}></i>
              {cat.name}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategoryNav;